import { useQuestionsStore } from "./questionStore";
import { useExerciseStore } from "./exerciseStore";
import { useSelfTestStore } from "./selfTestStore";
import { RouterConstant } from '../routers/index';
const { ROUTERS_PATH } = RouterConstant;


export const isMobileDevice = (): boolean => {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
};

export const validateExerciseName = (name: string): boolean => {
    if (!name.trim()) return false;
    return /^[\p{L}\p{N}_]+$/u.test(name);
};


export const resetExericeStore = (): void => {
    useQuestionsStore.getState().clearCurrentQuestions();
    useQuestionsStore.getState().clearSteps();  
    useExerciseStore.getState().resetParams();
    useQuestionsStore.getState().clearCharts();
    useExerciseStore.getState().setSelectedExerciseId(0);
    useExerciseStore.getState().clearCaptureImageSessionId();
    useSelfTestStore.getState().clearAll();
};

export const excludeTrackingPages = [
    ROUTERS_PATH.LOGIN,
    ROUTERS_PATH.STARTINGPAGE1,
    ROUTERS_PATH.ROOT_PATH,
    ROUTERS_PATH.USERREGISTRATIONINITIAL,
    ROUTERS_PATH.USERREGISTRATIONSTEP1,
    ROUTERS_PATH.USERREGISTRATIONOTP,
    ROUTERS_PATH.RESETPASSWORD,
    ROUTERS_PATH.DASHBOARD,
];

export const getChartSrc = (src: string) => {
    if (!src) return '';
    const trimmed = src.trim();
    // Check if it's raw SVG code (might start with <?xml or <svg)
    if (trimmed.startsWith('<svg') || trimmed.startsWith('<?xml')) {
        try {
            let svgContent = trimmed;
            // Ensure xmlns is present (required for data:image/svg+xml)
            if (!svgContent.includes('xmlns="http://www.w3.org/2000/svg"')) {
                svgContent = svgContent.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
            }
            const encoded = btoa(unescape(encodeURIComponent(svgContent)));
            return `data:image/svg+xml;base64,${encoded}`;
        } catch (e) {
            console.error("Failed to encode SVG", e);
            return src;
        }
    }
    return src;
};

export const compressImage = (file: File, maxWidth = 1600, maxHeight = 1600, quality = 0.8): Promise<Blob> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target?.result as string;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round((height * maxWidth) / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round((width * maxHeight) / height);
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(new Error('Canvas context not available'));
                    return;
                }

                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(new Error('Canvas to Blob conversion failed'));
                        }
                    },
                    'image/jpeg',
                    quality
                );
            };
            img.onerror = (err) => reject(err);
        };
        reader.onerror = (err) => reject(err);
    });
};


